import React from "react";

import { Line } from "@visx/shape";

import type { ThresholdProps } from "./types";

export const ThresholdLine = ({
  left,
  value,
  colour = "#0C2836",
  xMax,
  yMax,
  axis,
}: ThresholdProps) => {
  const from = {
    x: axis === "bottom" ? value : left,
    y: axis === "bottom" ? yMax + 5 : value,
  };

  const to = {
    x: axis === "bottom" ? value : xMax + 60,
    y: axis === "bottom" ? 5 : value,
  };

  return (
    <Line
      from={from}
      to={to}
      stroke={colour}
      strokeWidth={1}
      pointerEvents="none"
      strokeDasharray="3,5"
    />
  );
};
